import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  ApiResponse,
  PaginatedResponse,
} from "@/lib/types";
import {
  BlogTag,
  GetBlogTagsParams,
  CreateBlogTagRequest,
  UpdateBlogTagRequest
} from "@/types/blogTypes";

const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;

export const blogTagApi = createApi({
  reducerPath: "blogTagApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: "include",
  }),
  tagTypes: ["BlogTag"],
  endpoints: (builder) => ({
    createBlogTag: builder.mutation<ApiResponse<BlogTag>, CreateBlogTagRequest>({
      query: (data) => ({
        url: "/blog-tag/create-blog-tag",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["BlogTag"],
    }),
    getAllBlogTags: builder.query<PaginatedResponse<BlogTag>, GetBlogTagsParams | void>({
      query: (params) => ({
        url: "/blog-tag",
        params: params || undefined,
      }),
      providesTags: ["BlogTag"],
    }),
    getBlogTagById: builder.query<ApiResponse<BlogTag>, string>({
      query: (id) => `/blog-tag/${id}`,
      providesTags: ["BlogTag"],
    }),
    updateBlogTag: builder.mutation<ApiResponse<BlogTag>, UpdateBlogTagRequest>({
      query: ({ id, data }) => ({
        url: `/blog-tag/update-blog-tag/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["BlogTag"],
    }),
    deleteBlogTag: builder.mutation<ApiResponse, string>({
      query: (id) => ({
        url: `/blog-tag/delete-blog-tag/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["BlogTag"],
    }),
  }),
});

export const {
  useCreateBlogTagMutation,
  useGetAllBlogTagsQuery,
  useGetBlogTagByIdQuery,
  useUpdateBlogTagMutation,
  useDeleteBlogTagMutation,
} = blogTagApi;
